"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const images_1 = require("../../../../assets/images");
const scale_1 = require("../../../../utils/scale");
const CustomText_1 = __importDefault(require("../../../../components/text/CustomText"));
const helpler_1 = require("../../../../utils/helpler");
const rootNavigation_1 = require("../../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../../navigators/Routes"));
const Basic_1 = __importDefault(require("../../../../networking/apis/Basic"));
const ModalUnfollowUser_1 = __importDefault(require("../../../../components/modal/ModalUnfollowUser"));
const react_redux_1 = require("react-redux");
const constants_1 = require("../../../../constants");
const slice_1 = __importDefault(require("../../../../app-reduxs/app/slice"));
const components_1 = require("../../../../components");
const UserFollow = (props) => {
    const { data } = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    const myProfile = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    const [modalPosition, setModalPosition] = (0, react_1.useState)({ x: 0, y: 0 });
    const [followUser, setFollowUser] = (0, react_1.useState)(data?.is_followed || 0);
    const [visibleModalUnfolow, setVisibleModalUnfolow] = (0, react_1.useState)(false);
    const refIsCallingAPI = (0, react_1.useRef)(false);
    const isAnonymous = myProfile?.registration_status == 0;
    const handlePressShare = (event) => {
        const { pageX, pageY } = event.nativeEvent;
        setModalPosition({ x: pageX, y: pageY });
        setVisibleModalUnfolow(true);
    };
    const handleUnfollowUser = () => {
        const id = data?.user_id;
        if (refIsCallingAPI.current || !id)
            return;
        refIsCallingAPI.current = true;
        Basic_1.default.unfollowUser(id)
            .then(() => {
            setFollowUser(0);
            setVisibleModalUnfolow(false);
            dispatch(slice_1.default.actions.showToast(`${data.user_nickname || constants_1.DEFAULT_NAME}さんをフォロー解除しました`));
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => {
            refIsCallingAPI.current = false;
        });
    };
    const handleFollowUser = () => {
        if (isAnonymous) {
            return dispatch(slice_1.default.actions.showRequestLoginModal());
        }
        if (refIsCallingAPI.current)
            return;
        refIsCallingAPI.current = true;
        Basic_1.default.followUser(data.user_id)
            .then(() => {
            setFollowUser(1);
            dispatch(slice_1.default.actions.showToast(`${data.user_nickname || constants_1.DEFAULT_NAME}さんをフォローしました`));
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => {
            refIsCallingAPI.current = false;
        });
    };
    const navigateToUserProfile = () => {
        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
            screen: Routes_1.default.USER_PROFILE,
            params: {
                userHandle: data.user_handle
            }
        });
    };
    return (react_1.default.createElement(react_native_1.View, { style: { paddingHorizontal: (0, scale_1.scale)(16), paddingVertical: (0, scale_1.scale)(16) } },
        react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
            react_1.default.createElement(react_native_1.Pressable, { onPress: navigateToUserProfile },
                react_1.default.createElement(react_native_1.Image, { source: data?.user_thumbnail_url
                        ? data?.user_thumbnail_url
                        : images_1.images?.AvatarDefaul, style: {
                        height: (0, scale_1.scale)(42),
                        width: (0, scale_1.scale)(42),
                        borderRadius: 99,
                        marginRight: (0, scale_1.scale)(12),
                    } })),
            react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(170), marginRight: (0, scale_1.scale)(24) } },
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                        fontSize: (0, scale_1.moderateScale)(14),
                        lineHeight: (0, scale_1.moderateScale)(21),
                        color: '#292A33',
                        maxWidth: (0, scale_1.scale)(170),
                    }, numberOfLines: 1, onPress: navigateToUserProfile }, data?.user_nickname || constants_1.DEFAULT_NAME),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(10),
                        lineHeight: (0, scale_1.moderateScale)(17),
                        color: '#888888',
                        maxWidth: (0, scale_1.scale)(170),
                    }, numberOfLines: 1 },
                    "@",
                    data?.userHandle || data?.user_handle)),
            myProfile?.user_handle == data?.data?.userHandle ||
                myProfile?.user_handle == data?.user_handle ? (react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(96) } })) : (react_1.default.createElement(react_native_1.View, null, followUser == 0 ? (react_1.default.createElement(components_1.BorderButton, { title: "\u30D5\u30A9\u30ED\u30FC", onPress: handleFollowUser, style: {
                    width: (0, scale_1.scale)(96),
                    height: (0, scale_1.scale)(32),
                }, textStyle: { fontSize: (0, scale_1.moderateScale)(14) } })) : (react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                    width: (0, scale_1.scale)(96),
                    height: (0, scale_1.scale)(32),
                    borderRadius: (0, scale_1.scale)(4),
                    backgroundColor: '#DDDDDD',
                    justifyContent: 'center',
                    alignItems: 'center',
                }, onPress: handlePressShare },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(14),
                        lineHeight: (0, scale_1.moderateScale)(21),
                        color: '#545454',
                    } }, "\u30D5\u30A9\u30ED\u30FC\u4E2D")))))),
        react_1.default.createElement(react_native_1.View, { style: { marginTop: (0, scale_1.scale)(12), flexDirection: 'row' } },
            react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                    fontSize: (0, scale_1.moderateScale)(11),
                    lineHeight: (0, scale_1.moderateScale)(19),
                    color: '#545454',
                } }, (0, helpler_1.formatNumber)(data?.follows)),
            react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                    fontSize: (0, scale_1.moderateScale)(11),
                    lineHeight: (0, scale_1.moderateScale)(19),
                    color: '#545454',
                    marginRight: (0, scale_1.scale)(12),
                } }, "\u30D5\u30A9\u30ED\u30FC"),
            react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                    fontSize: (0, scale_1.moderateScale)(11),
                    lineHeight: (0, scale_1.moderateScale)(19),
                    color: '#545454',
                } }, (0, helpler_1.formatNumber)(data?.followers)),
            react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                    fontSize: (0, scale_1.moderateScale)(11),
                    lineHeight: (0, scale_1.moderateScale)(19),
                    color: '#545454',
                } }, "\u30D5\u30A9\u30ED\u30EF\u30FC")),
        !!data?.biography && (react_1.default.createElement(CustomText_1.default, { style: {
                color: '#292A33',
                fontSize: (0, scale_1.moderateScale)(15),
                lineHeight: (0, scale_1.moderateScale)(23),
                marginTop: (0, scale_1.scale)(12),
            } }, data?.biography?.split(helpler_1.hashtagRegex).map((string, index) => {
            if (string.match(helpler_1.hashtagRegex)) {
                return (react_1.default.createElement(react_native_1.Text, { key: index, style: { color: '#007AFF' }, onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                            screen: Routes_1.default.HASHTAG_DETAIL,
                            params: {
                                hashtag: string.slice(1),
                                typeScreen: 0,
                            },
                        });
                    } }, string));
            }
            else {
                return react_1.default.createElement(react_native_1.Text, { key: index }, string);
            }
        }))),
        react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                fontSize: (0, scale_1.moderateScale)(12),
                lineHeight: (0, scale_1.moderateScale)(18),
                color: '#545454',
                marginTop: (0, scale_1.scale)(12),
            } }, "\u30D5\u30A9\u30ED\u30FC\u3057\u3066\u3044\u308B\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0"),
        !!data?.hash_tags?.length && (react_1.default.createElement(react_native_1.View, { style: {
                flexDirection: 'row',
                flexWrap: 'wrap',
                marginTop: (0, scale_1.scale)(12),
            } }, data?.hash_tags?.map((item, index) => {
            return (react_1.default.createElement(CustomText_1.default, { key: index, style: {
                    maxWidth: '100%',
                    fontSize: (0, scale_1.moderateScale)(15),
                    fontWeight: '300',
                    lineHeight: (0, scale_1.moderateScale)(23),
                    color: '#007AFF',
                }, onPress: () => {
                    (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                        screen: Routes_1.default.HASHTAG_DETAIL,
                        params: {
                            typeScreen: 0,
                            hashtag: item?.name,
                            typeHashTag: 4,
                        },
                    });
                } }, `#${item?.name}`));
        }))),
        react_1.default.createElement(ModalUnfollowUser_1.default, { data: data, onClose: () => setVisibleModalUnfolow(false), visible: visibleModalUnfolow, modalPosition: modalPosition, onChange: () => handleUnfollowUser() })));
};
const styles = react_native_1.StyleSheet.create({
    confirmUnfollowButton: {
        position: 'absolute',
        right: (0, scale_1.scale)(18),
        height: (0, scale_1.scale)(58),
        width: (0, scale_1.scale)(130),
        borderRadius: (0, scale_1.scale)(3),
        backgroundColor: '#DDDDDD',
        justifyContent: 'center',
        alignItems: 'center',
    },
    textNote: {
        color: '#D32F2F',
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
    },
});
exports.default = UserFollow;
